const state = {
    info_sidebar_id: "",
    info_sidebar: false,
    info_sidebar_category: "",
    info_details: {},
    get_latest_category: ""
};

const mutations = {
    SET_INFO_SIDEBAR: (state) => {
        state.info_sidebar = !state.info_sidebar;
    },
    
    SET_INFO_SIDEBAR_ID: (state, id) => {
        state.info_sidebar_id = id;
    },

    SET_INFO_SIDEBAR_CATEGORY: (state, category) => {
        state.info_sidebar_category = category;
    },

    SET_INFO_SIDEBAR_OBJECT: (state, object) => {
        state.info_details = object;
    },

    SET_INFO_GET_LATEST_CATEGORY: (state, apiCategory) => {
        state.get_latest_category = apiCategory;
    }
};

const actions = {
    setInfoSidebarId({ commit }, id) {
        commit("SET_INFO_SIDEBAR_ID", id);
    },
    setInfoSidebar({ commit }) {
        commit("SET_INFO_SIDEBAR");
    },
    setInfoSidebarCategory({ commit }, category) {
        commit("SET_INFO_SIDEBAR_CATEGORY", category);
    },
    setInfoSidebarObject({ commit }, object) {
        commit("SET_INFO_SIDEBAR_OBJECT", object);
    },
    getAllLatestData({ commit }, getApiCategroy) {
        commit("SET_INFO_GET_LATEST_CATEGORY", getApiCategroy);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/vuex/modules/info_sidebar.js